import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-primary/30 bg-background py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-156" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-157" data-mp="2vp6c4b7o0i88">
        <div className="text-center" data-id="element-158" data-mp="39hcsnyeqcr87">
          <SectionHeading id="problem-title" data-id="element-159" data-mp="39gb4cs8pe88j">Does This Sound <span className="text-highlight" data-id="element-160" data-mp="35gki91u4ggac">Familiar?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-muted" data-id="element-161" data-mp="35in73ijjg3dh">
            You work with fire protection systems, or you want to grow in this field, but the full picture still feels
            fragmented. When someone talks about fire classes, addressable panels, sprinkler system types, fire pump tests,
            clean agent discharges or impairment procedures, you can&apos;t connect all the pieces with confidence.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-primary/70 bg-surface p-6 shadow-lg shadow-black/30 sm:p-8" data-id="element-162" data-mp="jeohcbefbqo8">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-extrabold uppercase text-foreground" data-id="element-163" data-mp="123v1m2uv8qc5">
            <AlertTriangleIcon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-164" data-mp="171wnevjof3rb" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-165" data-mp="1c33uesdzvywx">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-muted" data-id="element-166" data-mp="1g3nrjvykj2j2">
                <span className="glow-line mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-highlight" aria-hidden="true" data-id="element-167" data-mp="3dtnnw3626t4i" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-168" data-mp="p00kvq7g3mz4">
          <p className="mx-auto max-w-2xl text-lg font-bold text-foreground" data-id="element-169" data-mp="p0sj78sffyt3">
            You don&apos;t need more scattered information.
          </p>
          <p className="mt-3 text-2xl font-extrabold uppercase tracking-tight text-accent sm:text-3xl" data-id="element-170" data-mp="y0p3yzbp4div">You need one organized system.</p>
        </div>
      </div>
    </section>;
}